import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { getCasePhaseMeta } from '../../../app/helpers/flowCasePhaseHelper';

const FlowCasePhaseBadge = ({ phase = '', className = '', label = '' }) => {
  const { t } = useTranslation();
  const meta = getCasePhaseMeta(phase);
  const text = String(label || '').trim() || (meta ? t(meta.key, meta.fallback) : '');
  if (!text) {
    return null;
  }

  return (
    <span className={`badge bg-${meta?.tone || 'warning'} ${className}`.trim()}>
      {text}
    </span>
  );
};

FlowCasePhaseBadge.propTypes = {
  phase: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string
};

export default FlowCasePhaseBadge;
